// extracted by mini-css-extract-plugin
module.exports = {"col1":"ItemLog_col1__1gk2v","col2":"ItemLog_col2__S1LJh","col11":"ItemLog_col11__SL17P","col12":"ItemLog_col12__26FoC"};